<!-- <hr>{{user|json}} -->
<!-- Flex container wrapper -->
<div class="d-flex align-items-start custom-vertical-tabs my-2 gap-2">

  <!-- Navigation Left Sidebar -->
  <div class="nav flex-column nav-pills col-md-2" id="v-pills-tab" role="tablist" aria-orientation="vertical">
    <button class="nav-link active" id="v-pills-tab1" data-bs-toggle="pill" data-bs-target="#tab1_content" type="button"
      role="tab" aria-controls="tab1_content" aria-selected="true">
      Institute Details
    </button>
    <button class="nav-link" id="v-pills-tab2" data-bs-toggle="pill" data-bs-target="#tab2_content" type="button"
      role="tab" aria-controls="tab2_content" aria-selected="false">
      Contacts
    </button>
    <button class="nav-link" id="v-pills-tab3" data-bs-toggle="pill" data-bs-target="#tab3_content" type="button"
      role="tab" aria-controls="tab3_content" aria-selected="false">
      Billing Details
    </button>
    <button class="nav-link" id="v-pills-tab4" data-bs-toggle="pill" data-bs-target="#tab4_content" type="button"
      role="tab" aria-controls="tab4_content" aria-selected="false">
      Organization
    </button>
    <button class="nav-link" id="v-pills-tab5" data-bs-toggle="pill" data-bs-target="#tab5_content" type="button"
      role="tab" aria-controls="tab5_content" aria-selected="false" [hidden]="formData.institute.org_id == 'DEMO'">
      Package Details
    </button>
    <button class="nav-link" id="v-pills-tab6" data-bs-toggle="pill" data-bs-target="#tab6_content" type="button"
      role="tab" aria-controls="tab6_content" aria-selected="false">
      Payment Details
    </button>
  </div>

  <!-- Content Right Panel -->
  <div class="tab-content flex-grow-1 col-md-10" id="v-pills-tabContent">
    <div class="tab-pane fade show active p-2" id="tab1_content" role="tabpanel" aria-labelledby="tab1_content-tab"
      tabindex="0">
      <h4>Institute Details</h4>
      <div class="row g-3">
        <div class="col-3">
          <label class="form-label">Organization UUID</label>
          <input type="text" class="form-control" name="website" [(ngModel)]="formData.institute.org_id" disabled>
        </div>

        <div class="col-6">
          <label class="form-label">Institute Code</label>
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Generated Institute ID" 
            aria-label="Institute ID" aria-describedby="button-addon2" readonly [(ngModel)]="formData.institute.inst_code"
              [disabled]="formData.institute.org_id == 'DEMO'">
            <button class="btn btn-primary" type="button" id="button-addon2" (click)="genCustomInstID()"
              [disabled]="formData.institute.org_id == 'DEMO' || formData.institute.inst_code">Get Institute ID</button>
          </div>
        </div>
      </div>

      <div class="row g-3 mt-2">
        <div class="col-md-6">
          <label class="form-label">Institute Name</label>
          <!-- <input class="form-control" required name="inst_name" [(ngModel)]="formData.institute.inst_name"> -->
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Institute Name" 
            aria-label="inst_name" aria-describedby="button-addon2" [(ngModel)]="formData.institute.inst_name">
            <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" 
              id="button-addon2" (click)="doInstSearch();">
              <i class="bi bi-search"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-end px-2" style="max-height: 250px; overflow: auto;">
              @for(a of existedInsts; track $index; let idx=$index;) {
              <div class="card mb-2 bg-light bg-light-subtle">
                <div class="card-body py-1">
                  <div class="card-text mb-1">
                    <b>{{a.inst_name}}</b> ({{a.inst_type}})<br>
                    City: {{a.city}}
                  </div>
                  <div class="d-flex align-items-center justify-content-between">
                    <button type="button" class="btn btn-sm btn-warning py-0 my-2"
                      (click)="selectInst(a)">Select!</button>
                  </div>
                </div>
              </div>
              } @empty {
                <div align="center">Not found!</div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label">Institute Type</label>
          <!-- <input class="form-control" required name="board" [(ngModel)]="formData.institute.inst_type"> -->
          <select class="form-select" [(ngModel)]="formData.institute.inst_type">
            <option value="">Select</option>
            @for(it of dataService.institute_types; track $index;) {
            <option value="{{it.code}}">{{it.name}}</option>
            }
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Reg./Affiliation No.</label>
          <input type="text" class="form-control" required name="reg" [(ngModel)]="formData.institute.reg_no">
        </div>
      </div>

      <div class="row g-3 mt-2">
        <div class="col-md-5">
          <label class="form-label">Website</label>
          <input type="text" class="form-control" required name="website" [(ngModel)]="formData.institute.website"
            placeholder="http://">
        </div>
        <div class="col-md-4">
          <label class="form-label">GST No.</label>
          <input type="text" class="form-control" required name="gst" [(ngModel)]="formData.institute.gst_no">
        </div>
        <div class="col-md-3">
          <label class="form-label">Phone No</label>
          <input class="form-control" required name="phone_no" [(ngModel)]="formData.institute.phone_no">
        </div>
      </div>

      <div class="row g-3 mt-2">
        <div class="col-md-8">
          <label class="form-label">Address</label>
          <textarea class="form-control addressBox" rows="5" [(ngModel)]="formData.institute.address"></textarea>
        </div>
        <div class="col-md-4">
          <label class="form-label">State/City/Pincode</label>
          <div class="mb-1">
            <!-- <label class="form-label">
                  State
              </label> -->
            <select class="form-select" [(ngModel)]="formData.institute.state"
              (change)="formData.institute.district = dataService.getDist(formData.institute.state)">
              <option>Select State</option>
              @for(st of dataService.cityDataDD; track $index) {
              <option>{{st.state}}</option>
              }
            </select>
          </div>
          <div class="mb-1">
            <!-- <label class="form-label">
                  City
              </label> -->
            <select class="form-select" [(ngModel)]="formData.institute.city">
              <option>Select City</option>
              @for(dist of formData.institute.district; track $index) {
              <option>{{dist}}</option>
              }
            </select>
          </div>
          <input type="tel" class="form-control mb-1" [(ngModel)]="formData.institute.pincode" placeholder="Pincode">
        </div>
      </div>
    </div>

    <div class="tab-pane fade p-2" id="tab2_content" role="tabpanel" aria-labelledby="tab2_content-tab" tabindex="0">
      <h4>Contacts Details</h4>
      <div class="mb-2 mt-0 text-danger"><b>Note</b>: You must assign at least one contact as 'ERP Admin' to ensure new login details are received.</div>
      <div *ngFor="let contact of formData.contacts; let i=index" class="card mb-3 border">
        <div class="card-header d-flex justify-content-between">
          <strong> Contact {{i+1}}
          </strong>
          <button *ngIf="formData.contacts.length>1" class="btn btn-danger btn-sm" (click)="removeContact(i)"> Remove </button>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-4">
              <input class="form-control" placeholder="Contact Name" [(ngModel)]="contact.person_name" name="name{{i}}">
            </div>
            <div class="col-md-4">
              <!-- <input class="form-control" placeholder="Designation" [(ngModel)]="contact.person_desi"
                name="designation{{i}}"> -->
              <select class="form-select" [(ngModel)]="contact.person_desi" name="designation{{i}}">
                <option value="">Select Designation</option>
                @for(d of dataService.designations; track $index) {
                  <option value="{{d.code}}">{{d.name}}</option>
                }
              </select>
            </div>
            <div class="col-md-4">
              <!-- <input class="form-control" placeholder="Department" [(ngModel)]="contact.department"
                name="department{{i}}"> -->
              <select class="form-select" [(ngModel)]="contact.department" name="department{{i}}">
                <option value="">Select Department</option>
                @for(d of dataService.departments; track $index) {
                  <option value="{{d.code}}">{{d.name}}</option>
                }
              </select>
            </div>
            <div class="col-md-4">
              <input type="tel" class="form-control" placeholder="Mobile" [(ngModel)]="contact.mobile_no1" name="mobile{{i}}"
                maxlength="10">
            </div>
            <div class="col-md-4">
              <input type="tel" class="form-control" placeholder="Alternate Mobile" [(ngModel)]="contact.mobile_no2"
                name="altmobile{{i}}" maxlength="10">
            </div>
            <div class="col-md-4">
              <input type="email" class="form-control" placeholder="Email" [(ngModel)]="contact.email_id"
                name="email{{i}}">
            </div>
            <div class="col-12">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" [checked]="contact.is_primary" (change)="setPrimary(i)">
                <label class="form-check-label"> Primary Contact </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="btn btn-sm btn-success" (click)="addContact()"> Add Contact </button>
    </div>

    <div class="tab-pane fade p-2" id="tab3_content" role="tabpanel" aria-labelledby="tab3_content" tabindex="0">
      <div class="d-flex gap-3">
        <h4>Billing Details</h4>
        <button class="btn btn-sm btn-outline-primary d-flex align-items-center py-0" 
          style="height: 24px; font-size: 12px;" (click)="fetchInst()">
          Fetch From Institute
        </button>
      </div>

      <div class="row g-3">
        <div class="col-md-6">
          <input class="form-control" placeholder="Billing Name" [(ngModel)]="formData.billing.billing_name">
        </div>
        <div class="col-md-3">
          <input class="form-control" placeholder="GST Number" [(ngModel)]="formData.billing.gst_no">
        </div>
        <div class="col-md-3">
          <input class="form-control" placeholder="GST State Code" [(ngModel)]="formData.billing.gst_state_code">
        </div>
        <div class="row g-3 mt-2">
          <div class="col-md-8">
            <label class="form-label">Address</label>
            <textarea class="form-control addressBox" rows="5" [(ngModel)]="formData.billing.address"></textarea>
          </div>
          <div class="col-md-4">
            <label class="form-label">State/City/Pincode</label>
            <div class="mb-1">
              <!-- <label class="form-label">
                    State
                </label> -->
              <select class="form-select" [(ngModel)]="formData.billing.state"
                (change)="formData.billing.district = dataService.getDist(formData.billing.state)">
                <option>Select State</option>
                @for(st of dataService.cityDataDD; track $index) {
                <option>{{st.state}}</option>
                }
              </select>
            </div>
            <div class="mb-1">
              <!-- <label class="form-label">
                    City
                </label> -->
              <select class="form-select" [(ngModel)]="formData.billing.city">
                <option>Select City</option>
                @for(dist of formData.billing.district; track $index) {
                <option>{{dist}}</option>
                }
              </select>
            </div>
            <input type="tel" class="form-control mb-1" [(ngModel)]="formData.billing.pincode" placeholder="Pincode">
          </div>
        </div>

      </div>
    </div>

    <div class="tab-pane fade p-2" id="tab4_content" role="tabpanel" aria-labelledby="tab4_content-tab" tabindex="0">
      <h4>Organization Details</h4>
      <div>
        @if (formData.organization.org_exists) {
        <div class="checkbox-group mx-3 mb-3">
          <label class="checkbox-label d-flex">
            <!-- <input type="checkbox" [checked]="formData.organization.org_exists" /> -->
            <i class="bi bi-check2-square" *ngIf="formData.organization.org_exists"></i>
            <i class="bi bi-x-square" *ngIf="!formData.organization.org_exists"></i>
            <span class="ms-3" style="line-height: normal;">
              Sister concern institute already under the same organization.<br>
              Macwill admin has to confirm payment and assign organization ID.
            </span>
          </label>
        </div>
        }
        <div class="row g-3">
          <div class="col-3">
            <label class="form-label">Organization Code</label>
            <input type="text" class="form-control" placeholder="Generated Organization ID" 
            aria-label="Organization ID" aria-describedby="button-addon2" readonly  
            [(ngModel)]="formData.organization.org_code">
          </div>

          <div class="col-6">
            <label class="form-label">Organization Name <span class="required">*</span>
            </label>
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Organization Name" 
                aria-label="organizationName" aria-describedby="button-addon2" 
                [(ngModel)]="formData.organization.org_name" [disabled]="formData.institute.org_id == 'DEMO'">
              <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" 
                id="button-addon2" (click)="doOrgSearch();" [disabled]="formData.institute.org_id == 'DEMO'">
                <i class="bi bi-search"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-end px-2" style="max-height: 250px; overflow: auto;">
                @for(o of existedOrgs; track $index;) {
                <div class="card mb-2 bg-light bg-light-subtle">
                  <div class="card-body py-1">
                    <div class="card-text mb-1">
                      <b>{{o.org_name}}</b><br>
                      Code: {{o.org_code}}
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                      <button type="button" class="btn btn-sm btn-warning py-0 my-2"
                        (click)="selectOrg(o)">Select!</button>
                    </div>
                  </div>
                </div>
                } @empty {
                  <div align="center">Not found!</div>
                }
              </div>
            </div>
          </div>

          <!-- Registration Date -->
          <div class="col-3">
            <label class="form-label">Reg. Date</label>
            <input type="date" id="reg_date" name="reg_date" class="form-control" 
              [(ngModel)]="formData.organization.reg_date">
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-8">
              <label class="form-label">Address</label>
              <textarea class="form-control addressBox" rows="5" [(ngModel)]="formData.organization.org_address"></textarea>
            </div>
            <div class="col-md-4">
              <label class="form-label">State/City/Pincode</label>
              <div class="mb-1">
                <!-- <label class="form-label">
                      State
                  </label> -->
                <select class="form-select" [(ngModel)]="formData.organization.org_state"
                  (change)="formData.organization.district = dataService.getDist(formData.organization.org_state)">
                  <option>Select State</option>
                  @for(st of dataService.cityDataDD; track $index) {
                  <option>{{st.state}}</option>
                  }
                </select>
              </div>
              <div class="mb-1">
                <!-- <label class="form-label">
                      City
                  </label> -->
                <select class="form-select" [(ngModel)]="formData.organization.org_city">
                  <option>Select City</option>
                  @for(dist of formData.organization.district; track $index) {
                  <option>{{dist}}</option>
                  }
                </select>
              </div>
              <input type="tel" class="form-control mb-1" [(ngModel)]="formData.organization.org_pincode"
                placeholder="Pincode">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-pane fade p-2" id="tab5_content" role="tabpanel" aria-labelledby="tab5_content" tabindex="0">
      <h4>Package Details</h4>
      <div>
        <!-- Expiring Message -->
        <div class="topbar-center blink-text text-center text-danger" *ngIf="reNewAlert">
          <i class="bi bi-hourglass-split"></i>
          Your subscription ends on [{{user.exp_date|date}}]. Re-new it soon to keep your services running.
          <!-- <a [routerLink]="['/dashboard/', dataService.myEncrypt('kyc')]">Re-New!</a> -->
        </div>

        <div class="row g-3">
          <!-- Statistics -->
          <div class="row g-3 mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="card stat-card bg-info text-dark bg-opacity-10">
                <div class="card-body text-center">
                  <small>Current Plan</small>
                  <h5 class="m-0">{{getPackName()}}</h5>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card stat-card bg-secondary text-dark bg-opacity-10">
                <div class="card-body text-center">
                  <small>Billing Cycle</small>
                  <h5 class="m-0">{{formData.package.bill_cycle}}</h5>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card stat-card bg-warning text-dark bg-opacity-10">
                <div class="card-body text-center">
                  <small>Students</small>
                  <h5 class="m-0">{{formData.package.std_counts}}</h5>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card stat-card bg-success text-dark bg-opacity-10">
                <div class="card-body text-center">
                  <small>Package Amount</small>
                  <h5 class="m-0">₹ {{formData.package.total_amount}}/-</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row g-4 my-3">
          <div class="form-card">
            <h2 align="center">Terms and Conditions</h2>
            <p align="center" class="section-desc">Please read and accept our terms and conditions</p>

            <div class="terms-content">
              <div class="terms-box">
                <h4>Service Agreement</h4>
                <p>By subscribing to Macwill ERP, you agree to the following terms:</p>
                <ul>
                  <li>The subscription is valid for the selected billing cycle from the date of payment confirmation.
                  </li>
                  <li>The number of students is limited to the quantity selected during purchase.</li>
                  <li>Data backup is provided according to your selected plan.</li>
                  <li>The service can be renewed before expiry to ensure uninterrupted access.</li>
                  <li>All prices are inclusive of applicable taxes.</li>
                  <li>Macwill reserves the right to suspend services for non-payment or policy violations.</li>
                  <li>Refunds are processed within 7-10 business days subject to approval.</li>
                </ul>
                <p>For complete terms, please refer to the Service Level Agreement document.</p>
              </div>
            </div>
            <div class="signature-section">
              <h5>Authorization Signature</h5>
              <div class="row">
                <div class="col-12 my-2">
                  <label for="consent">
                    <i class="bi bi-file-earmark-check text-success" *ngIf="formData.agreement.consent"></i>
                    <i class="bi bi-file-earmark-excel text-danger" *ngIf="!formData.agreement.consent"></i>
                    Yes, I read and accept the terms and conditions.
                  </label>
                </div>
                <div class="col-md-6">
                  <label>Name:</label>&nbsp;&nbsp; <b>{{formData.agreement.name}}</b>
                </div>
                <div class="col-md-6">
                  <label>Designation:</label>&nbsp;&nbsp; <b>{{dataService.getDesiName(formData.agreement.designation)}}</b>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="tab-pane fade p-2" id="tab6_content" role="tabpanel" aria-labelledby="tab6_content-tab" tabindex="0">
      <h4>Payment Verification</h4>
      <p>At subscription or KYC details time, user has pay the package amount via online or offline. Admin has to verify
        the received payment to complete the subscription.</p>
      <!-- <p>Institute had pay Online/Offline amount Rs. 0.00/- on dated 22-06-2026</p> -->
      <!-- Pricing Summary -->
      <div class="pricing-summary col-lg-12">
        <div class="card shadow-sm">
          <div class="card-header" style="padding: 5px 15px !important;">
            Order Summary
          </div>
<!-- {{formData.package|json}} -->
          <div class="card-body" *ngIf="formData.package && formData.package.pkg_code">
            <div class="row d-flex justify-content-between">
              <div class="col-5" style="line-height: 35px;">
                <div class="summary-row">
                  <span>Package / Plan:</span> <span>{{ getPackName() }}</span>
                </div>
                <div class="summary-row">
                  <span>Custom Modules:</span> <span>{{ formData.package.selected_modules.length || 'Default' }}</span>
                </div>
                <div class="summary-row">
                  <span>Billing Cycle:</span> <span>{{ formData.package.bill_cycle }}</span>
                </div>
                <div class="summary-row">
                  <span>Students:</span> <span>{{ formData.package.std_counts | number }}</span>
                </div>
              </div>
              <!-- <div class="summary-divider"></div> -->
              <div class="col-5" style="line-height: 35px;">
                <div class="summary-row">
                  <span>Base Amount</span>
                  <span>₹ {{ $any(formData.package).base_amount }}/-</span>
                </div>
                <!-- @if (pricing.discountAmount >= 0) { -->
                <div class="summary-row discount">
                  <span>Discount (-)</span>
                  <span>₹ {{ $any(formData.package).discount_amount || 0 }}/-</span>
                </div>
                <!-- } -->
                <div class="summary-row">
                  <span>Subtotal</span>
                  <span>₹ {{ $any(formData.package).net_amount }}/-</span>
                </div>
                <div class="summary-row">
                  <span>GST (18%)</span>
                  <span>₹ {{ $any(formData.package).tax_amount }}/-</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="summary-divider col-12"></div>
              <div class="summary-row total col-12 px-3">
                <span>Total Amount (Paid {{$any(formData.package).paid_offline ? 'Offline' : 'Online'}})</span>
                <span>₹ {{ $any(formData.package).total_amount }}/-</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-center my-2 mb-3 flex-column">       
        <div class="row col-11" *ngIf="formData.institute.org_id !== 'DEMO' && formData.package.bill_cycle !== 'days'">
          <div class="col-6 licKey">
            <label class="form-label">Generate a new license key:</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="Generated License Key" aria-label="License Key" 
              aria-describedby="button-addon2" readonly [(ngModel)]="formData.institute.agr_lickey">
              <button class="btn btn-primary" type="button" id="button-addon2" (click)="genLicKey()">
                Get New License Key</button>
            </div>
          </div>
        </div>

        <div class="row col-11 mt-1 d-flex align-items-center">
          <div class="col-3">Start Date: 
            <input type="date" class="form-control form-control-sm" [(ngModel)]="formData.package.start_date"
            (change)="getExpiry(formData.package.start_date)">
          </div>
          <div class="col-3">Expiry Date: 
            <input type="date" class="form-control form-control-sm" [(ngModel)]="formData.package.exp_date">
          </div>
          <div class="col-6 text-end">
            <button class="btn btn-sm btn-success px-3 py-1" (click)="onBoardingSetup()">
              Yes, Confirmed.<br>Proceed to on-board Now!</button>
          </div>
        </div>
        <div class="row col-11 mt-3 d-flex align-items-center">
          <small class="text-danger">
            <b>NOTE</b>: Carefully verify all details before proceed. Once you click the button,
              all details will be transfer to live database and user status will be update accordingly.
          </small>
        </div>
      </div>
    </div>
  </div>

</div>

<div aria-live="polite" aria-atomic="true" class="bg-body-secondary position-relative bd-example-toasts"
  [hidden]="!dataService.onBoarding"
  style="position: fixed !important; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999; 
    background-color: rgba(0,0,0,0.5) !important;">
  <div class="toast-container p-3 top-40 start-50 translate-middle" id="toastPlacement">
    <div class="toast fade" [class.show]="dataService.onBoarding">
      <div class="toast-header">
        <i class="bi bi-hourglass-split me-2"></i>
        <strong class="me-auto">On Boarding Setup</strong>
        <small>in progress</small>
      </div>
      <div class="toast-body">
        <p align="center">After fully verify the details and payment, on boarding process is running. Please wait until
          complete it.</p>

        <div class="progress mb-2" role="progressbar" aria-label="Animated striped example" aria-valuemin="0"
          aria-valuemax="100" aria-valuenow="{{progress}}">
          <div class="progress-bar progress-bar-striped progress-bar-animated" [ngStyle]="{width: progress+'%'}"></div>
        </div>

        <small><b>Attension!</b> Please do not refresh or close browser.</small>
      </div>
    </div>
  </div>
</div>
